import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { approvalByPhone } from "../api/menupro.api";
import "./waiting.css";

export default function Waiting() {
  const { phone } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("PENDING");
  const [reason, setReason] = useState("");

  const adminPhone = "994709559984"; // wa.me üçün + işarəsiz
  const waText = `Salam. Biznes səhifəsi üçün zəhmət olmasa sorğumu qəbul edəsiniz. Telefon nömrəsi: ${phone}`;
  const waLink = `https://wa.me/${adminPhone}?text=${encodeURIComponent(waText)}`;

  useEffect(() => {
    if (!phone) return;
    let alive = true;

    const load = async () => {
      try {
        setLoading(true);
        const res = await approvalByPhone(phone);
        const b = res.data || {};
        if (!alive) return;

        setStatus(b.approvalStatus || "PENDING");
        setReason(b.rejectReason || "");
      } catch (e) {
        if (!alive) return;
      } finally {
        if (alive) setLoading(false);
      }
    };

    load();
    const t = setInterval(load, 3000);

    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [phone]);

  const isApproved = status === "APPROVED";
  const isRejected = status === "REJECTED";

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">MenuPro</h1>

        <p className="auth-subtitle">
          Sorğunuz yoxlanılır: <b>{phone}</b>
        </p>

        {/* ✅ Admin ilə əlaqə düyməsi */}
        <a
          className="auth-button outline"
          href={waLink}
          target="_blank"
          rel="noreferrer"
          style={{
            marginTop: 10,
            textDecoration: "none",
            display: "block",
            textAlign: "center",
          }}
        >
          💬 Admin ilə əlaqə (WhatsApp)
        </a>

        {loading ? (
          <div style={{ color: "#888", marginTop: 12 }}>Yüklənir...</div>
        ) : isApproved ? (
          <>
            <div className="auth-banner info" style={{ marginTop: 12 }}>
              ✅ Təsdiqləndi! İndi giriş edə bilərsiniz.
            </div>
            <button className="auth-button" onClick={() => navigate("/menupro/login")}>
              Girişə keç
            </button>
          </>
        ) : isRejected ? (
          <>
            <div className="auth-banner error" style={{ marginTop: 12 }}>
              ❌ Sorğunuz rədd edildi{reason ? `: ${reason}` : "."}
            </div>
            <Link className="auth-link" to="/menupro/register">
              Yenidən qeydiyyat
            </Link>
          </>
        ) : (
          <>
            <div className="auth-banner info" style={{ marginTop: 12 }}>
              ⏳ Gözləmədədir. Admin təsdiqləyəndə avtomatik yenilənəcək.
            </div>
            <div style={{ marginTop: 12, color: "#888", fontSize: 13 }}>
              (Hər 3 saniyədən bir yoxlanılır)
            </div>
          </>
        )}
      </div>
    </div>
  );
}
